namespace RioERP.Products {
    export interface ProductsRow {
        Id?: number;
        ProductName?: string;
        Thumbnail?: string;
        ProductDisplayName?: string;
        Description?: string;
        WebsiteUrl?: string;
        EProductType?: Web.Enums.ProductType;
        ERioplayVersion?: Web.Enums.RioShieldVersion;
        RioplayProductCode?: string;
        SkuCode?: string;
        DownloadUrl1?: string;
        DownloadUrl2?: string;
        TeacherName?: string;
        HasPenDrive?: boolean;
        HasBooks?: boolean;
        IsCombo?: boolean;
        HasCourier?: boolean;
        Note?: string;
        Weight?: number;
        Height?: number;
        Width?: number;
        Length?: number;
        EPackingType?: Web.Enums.PackingType;
        DefaultFranchiseeSharePercentage?: number;
        GrossAmount?: number;
        EOpens?: Web.Enums.EOpens;
        EWatchTime?: Web.Enums.EWatchTime;
        EValidity?: Web.Enums.EValidity;
        EValidityType?: Web.Enums.EValidityType;
        TotalAllowedDuration?: number;
        PackId?: number;
        AllowSerialKeyGeneration?: boolean;
        AllowedDevices?: string;
        ProductIds?: string;
        AllowedDevice?: number[];
        ComboProductId?: number[];
        IsLive?: boolean;
        ProcesOrderOnPaid?: boolean;
        ActivateSerialKey?: boolean;
        EAccessStatus?: Web.Enums.AccessStatus;
        InAppDownload?: boolean;
        HasVod?: boolean;
        TemplateSerialKeyId?: number;
        IsActive?: boolean;
        ValidTill?: string;
        ProductCategList?: number[];
        RioPlayTenantId?: number;
        Secretkey?: string;
        RowIds?: string;
        PackTags?: string;
        VendorId?: number;
        VendorUserId?: number;
        SupportInfo?: string;
        ProductQueryInfo?: string;
        EShippedby?: Web.Enums.ShippedBy;
        UserName?: string;
        Rioplay8ProductCode?: string;
        Rioplay8ESubscriptionType?: Web.Enums.ESubscriptionType;
        Rioplay8EViewsType?: Rio.Enums.EViewType;
        Rioplay8EWatchTimetype?: Rio.Enums.EWatchTimetype;
        Rioplay8ViewsPerContent?: number;
        Rioplay8WatchTime?: number;
        Rioplay8AllowedDevices?: string;
        Rioplay8EDeviceRestrictionType?: Rio.Enums.EDeviceRestrictionType;
        Rioplay8DeviceCount?: number;
        Rioplay8SwitchCount?: number;
        Rioplay8ValidityInDays?: number;
        Rioplay8ValidDate?: string;
        Rioplay8TenantId?: string;
        Rioplay8AllowedDevice?: string[];
        Rioplay8PlaylistIds?: string;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace ProductsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'ProductDisplayName';
        export const localTextPrefix = 'Products.Products';
        export const lookupKey = 'Products.Products';

        export function getLookup(): Q.Lookup<ProductsRow> {
            return Q.getLookup<ProductsRow>('Products.Products');
        }
        export const deletePermission = 'Products:ProductsManagement:Modify';
        export const insertPermission = 'Products:ProductsManagement:Modify';
        export const readPermission = 'Products:ProductsManagement:View';
        export const updatePermission = 'Products:ProductsManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            ProductName = "ProductName",
            Thumbnail = "Thumbnail",
            ProductDisplayName = "ProductDisplayName",
            Description = "Description",
            WebsiteUrl = "WebsiteUrl",
            EProductType = "EProductType",
            ERioplayVersion = "ERioplayVersion",
            RioplayProductCode = "RioplayProductCode",
            SkuCode = "SkuCode",
            DownloadUrl1 = "DownloadUrl1",
            DownloadUrl2 = "DownloadUrl2",
            TeacherName = "TeacherName",
            HasPenDrive = "HasPenDrive",
            HasBooks = "HasBooks",
            IsCombo = "IsCombo",
            HasCourier = "HasCourier",
            Note = "Note",
            Weight = "Weight",
            Height = "Height",
            Width = "Width",
            Length = "Length",
            EPackingType = "EPackingType",
            DefaultFranchiseeSharePercentage = "DefaultFranchiseeSharePercentage",
            GrossAmount = "GrossAmount",
            EOpens = "EOpens",
            EWatchTime = "EWatchTime",
            EValidity = "EValidity",
            EValidityType = "EValidityType",
            TotalAllowedDuration = "TotalAllowedDuration",
            PackId = "PackId",
            AllowSerialKeyGeneration = "AllowSerialKeyGeneration",
            AllowedDevices = "AllowedDevices",
            ProductIds = "ProductIds",
            AllowedDevice = "AllowedDevice",
            ComboProductId = "ComboProductId",
            IsLive = "IsLive",
            ProcesOrderOnPaid = "ProcesOrderOnPaid",
            ActivateSerialKey = "ActivateSerialKey",
            EAccessStatus = "EAccessStatus",
            InAppDownload = "InAppDownload",
            HasVod = "HasVod",
            TemplateSerialKeyId = "TemplateSerialKeyId",
            IsActive = "IsActive",
            ValidTill = "ValidTill",
            ProductCategList = "ProductCategList",
            RioPlayTenantId = "RioPlayTenantId",
            Secretkey = "Secretkey",
            RowIds = "RowIds",
            PackTags = "PackTags",
            VendorId = "VendorId",
            VendorUserId = "VendorUserId",
            SupportInfo = "SupportInfo",
            ProductQueryInfo = "ProductQueryInfo",
            EShippedby = "EShippedby",
            UserName = "UserName",
            Rioplay8ProductCode = "Rioplay8ProductCode",
            Rioplay8ESubscriptionType = "Rioplay8ESubscriptionType",
            Rioplay8EViewsType = "Rioplay8EViewsType",
            Rioplay8EWatchTimetype = "Rioplay8EWatchTimetype",
            Rioplay8ViewsPerContent = "Rioplay8ViewsPerContent",
            Rioplay8WatchTime = "Rioplay8WatchTime",
            Rioplay8AllowedDevices = "Rioplay8AllowedDevices",
            Rioplay8EDeviceRestrictionType = "Rioplay8EDeviceRestrictionType",
            Rioplay8DeviceCount = "Rioplay8DeviceCount",
            Rioplay8SwitchCount = "Rioplay8SwitchCount",
            Rioplay8ValidityInDays = "Rioplay8ValidityInDays",
            Rioplay8ValidDate = "Rioplay8ValidDate",
            Rioplay8TenantId = "Rioplay8TenantId",
            Rioplay8AllowedDevice = "Rioplay8AllowedDevice",
            Rioplay8PlaylistIds = "Rioplay8PlaylistIds",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
